<template>
  <Navbar :center-text="$t('ActivationView.accountActivation')"
          :message="this.message"
          :message-type="this.messageType">
  </Navbar>
  <div class="container container-login d-flex justify-content-center">
    <form @submit.prevent="handleActivation" style="display: block;">
      <div class="row">
        <div class="col-12 form-group mb-4">
          <strong>{{ $t('ActivationView.activateYourAccount') }}</strong>&nbsp;{{ email }}
        </div>
      </div>
      <div class="row">
        <div class="col-12 form-group mb-4">
          <label>
            {{ $t('ActivationView.enterActivationCode')}}
            <input class="form-control form-control-sm"
                   type="text"
                   v-model="code"/>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-4">
          <button type="submit"
                  class="btn btn-success rounded-pill mb-4 w-100"
                  v-if="showActivationButton">
            <i class="bi bi-check-circle-fill"></i>
            {{ $t('ActivationView.activate') }}
          </button>
          <button type="button"
                  class="btn btn-primary rounded-pill mb-4 w-100"
                  v-if="!showActivationButton"
                  @click="goToLogin">
            <i class="bi bi-person-fill"></i>
            {{ $t('goToLogin')}}
          </button>
        </div>
      </div>
    </form>
  </div>
  <Footerbar></Footerbar>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footerbar from "@/components/Footerbar.vue";
import {postActivation} from "@/utils";

export default {
  components: {
    Footerbar,
    Navbar
  },
  data() {
    return {
      email: atob(this.$route.params.email),
      code: '',
      showActivationButton: true,
      message: this.$t('yourAccountHasBeenRegistered'),
      messageType: 'info',
    };
  },
  methods: {
    async handleActivation() {
      let response = await postActivation(this.email, this.code);
      if(response.status === 200) {
        this.message = this.$t('yourAccountHasBeenActivated');
        this.messageType = "success";
        this.showActivationButton = false;
      } else {
        this.message = response.response.data.message;
        this.messageType = "danger";
      }
    },
    goToLogin() {
      this.$router.push({
        name: "root",
      });
    },
  }
};
</script>